import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const InitialRedirect = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return; // Wait for auth state

    if (!user) return; // Not logged in, do nothing

    // Redirect only if user is at root or login page
    const pathname = window.location.pathname;
    if (pathname === "/" || pathname === "/login") {
      if (user.role === "admin") {
        navigate("/admin/dashboard", { replace: true });
      } else {
        navigate("/user/dashboard", { replace: true });
      }
    }
  }, [user, loading, navigate]);

  return null;
};

export default InitialRedirect;
